import * as React from "react";
import type { SVGProps } from "react";
const SvgSnowflake = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.811 21.245 12 18.057m0 0 3.188 3.188M12 18.057V5.943m3.188-3.188L12 5.943m0 0L8.811 2.755M2.4 13.862l4.355 1.166m0 0-1.167 4.355m1.167-4.355 10.49-6.056m4.355 1.166-4.355-1.166m0 0 1.167-4.355m-12.824 0 1.167 4.355m0 0L2.4 10.138m4.355-1.166 10.49 6.056m1.167 4.355-1.167-4.355m0 0 4.355-1.166"
    />
  </svg>
);
export default SvgSnowflake;
